import MicroModal from "micromodal";
import { getScrollBarWidth } from "@/scripts/helpers/library";

const execYoutubeCommand = (frame, command) => {
  if (frame.contentWindow === null) {
    return;
  }

  frame.contentWindow.postMessage(
    window.JSON.stringify({ event: "command", func: command }),
    "https://www.youtube.com"
  );
};

const modalHandler = (modal, command) => {
  const iframes = modal.querySelectorAll("iframe");

  [].forEach.call(iframes, frame => {
    execYoutubeCommand(frame, command);
  });
};

export default () => {
  const lockClassName = "scroll-locked";
  const animationDuration = 250;

  MicroModal.init({
    awaitCloseAnimation: true,
    disableFocus: true,
    onShow: modal => {
      modalHandler(modal, "playVideo");
      $("body")
        .addClass(lockClassName)
        .css("padding-right", getScrollBarWidth());
    },
    onClose: modal => {
      modalHandler(modal, "pauseVideo");
      setTimeout(() => {
        $("body")
          .removeClass(lockClassName)
          .css("padding-right", "");
      }, animationDuration);
    }
  });
};
